// material-ui
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// project imports
import { ThemeMode } from 'config';
import useConfig from 'hooks/useConfig';

// assets
import lightThemeIcon from 'assets/images/light-theme.png';
import darkThemeIcon from 'assets/images/dark-theme.png';
import lightThemeIconSun from 'assets/images/light-theme-icon-sun.png';
import darkThemeIconMoon from 'assets/images/dark-theme-icon-moon.png';
import checkIcon from 'assets/images/icons/checkIcon.svg';
import { FormattedMessage } from 'react-intl';
// ==============================|| CUSTOMIZATION - MODE ||============================== //

export default function ThemeModeLayout() {
  const { mode, onChangeMode } = useConfig();
  const safeMode = mode === ThemeMode.DARK ? ThemeMode.DARK : ThemeMode.LIGHT;

  return (
    <Stack sx={{ justifyContent: 'space-between', width: '100%' }}>
      <Typography sx={{ fontSize: '16px', fontWeight: '500', mb: 2.5 }} color="grey.800" id="theme-mode-title">
        <FormattedMessage id="themeMode" defaultMessage="Theme Mode" />
        <Typography
          component="span"
          sx={{
            px: 1.5,
            py: 0.5,
            ml: 1,
            bgcolor: safeMode === ThemeMode.LIGHT ? '#E0F2F1' : '#455A64',
            textTransform: 'capitalize',
            borderRadius: 5,
            color: safeMode === ThemeMode.LIGHT ? 'teal.900' : 'white.paper'
          }}
        >
          {safeMode === ThemeMode.LIGHT ? (
            <FormattedMessage id="light" defaultMessage="Light" />
          ) : (
            <FormattedMessage id="dark" defaultMessage="Dark" />
          )}
        </Typography>
      </Typography>
      <RadioGroup
        row
        aria-label="layout"
        value={safeMode}
        onChange={(e) => onChangeMode(e.target.value)}
        name="row-radio-buttons-group"
        sx={{ gap: 2.5 }}
        id="themeType"
      >
        <FormControlLabel
          sx={{
            ml: 0,
            mr: 0,
            flex: '1',
            '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
              width: '100%'
            }
          }}
          control={<Radio value={ThemeMode.LIGHT} sx={{ display: 'none' }} />}
          id="lightTheme"
          label={
            <Box
              sx={{
                borderRadius: '10px',
                color: 'grey.100',
                overflow: 'hidden'
              }}
            >
              <Box sx={{ padding: '13px 18px', display: 'flex', flexDirection: 'column', bgcolor: '#E0F2F1', position: 'relative' }}>
                <Box component="img" src={lightThemeIconSun} width={36} alt="Light Theme"></Box>
                <Typography
                  sx={{
                    fontSize: '16px',
                    color: '#212121',
                    fontWeight: '500',
                    textAlign: 'center',
                    mt: 2
                  }}
                >
                  <FormattedMessage id="lightTheme" defaultMessage="Light Theme" />
                </Typography>
                <Typography
                  sx={{
                    fontSize: '14px',
                    color: '#616161',
                    fontWeight: '400',
                    textAlign: 'center',
                    mb: 2
                  }}
                >
                  <FormattedMessage id="lightThemeDescription" defaultMessage="Bright and clean interface" />
                </Typography>
                <Box
                  component="img"
                  src={checkIcon}
                  alt="Check Icon"
                  width={20}
                  height={20}
                  sx={{ display: safeMode === ThemeMode.LIGHT ? 'block' : 'none', position: 'absolute', top: '22px', right: '18px' }}
                />

                <Box>
                  <img src={lightThemeIcon} width={'100%'} alt="Light Theme" />
                </Box>
              </Box>
            </Box>
          }
        />
        <FormControlLabel
          sx={{
            ml: 0,
            marginRight: '0',
            flex: '1',
            '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
              width: '100%'
            }
          }}
          control={<Radio value={ThemeMode.DARK} sx={{ display: 'none' }} />}
          id="darkTheme"
          label={
            <Box
              sx={{
                borderRadius: '10px',
                color: 'grey.100',
                overflow: 'hidden'
              }}
            >
              <Box sx={{ padding: '13px 18px', display: 'flex', flexDirection: 'column', bgcolor: '#2b3749', position: 'relative' }}>
                <Box component="img" src={darkThemeIconMoon} width={36} alt="Dark Theme"></Box>
                <Typography
                  sx={{
                    fontSize: '16px',
                    color: '#FAFAFA',
                    fontWeight: '500',
                    textAlign: 'center',
                    mt: 2
                  }}
                >
                  <FormattedMessage id="darkTheme" defaultMessage="Dark Theme" />
                </Typography>
                <Typography
                  sx={{
                    fontSize: '14px',
                    color: '#BDBDBD',
                    fontWeight: '400',
                    textAlign: 'center',
                    mb: 2
                  }}
                >
                  <FormattedMessage id="darkThemeDescription" defaultMessage="Easy on the eyes" />
                </Typography>
                <Box
                  component="img"
                  src={checkIcon}
                  alt="Check Icon"
                  width={20}
                  height={20}
                  sx={{ display: safeMode === ThemeMode.LIGHT ? 'none' : 'block', position: 'absolute', top: '22px', right: '18px' }}
                />

                <Box>
                  <Box component="img" src={darkThemeIcon} width={'100%'} alt="Dark Theme" />
                </Box>
              </Box>
            </Box>
          }
        />
      </RadioGroup>
    </Stack>
  );
}
